module.exports = "/images/gl.svg?41b14e2eaf143b3e8f21cbe8572a51c2";